import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Skeleton,
    Stack,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, Menu, MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Spinner from "../../components/Spinner/Spinner";
import {
    AddPenyewaCoWork,
    DataPenyewa,
    IDataTambahInvoice,
    ParamsGetListInvoicePenyewa,
    ParamsGetListPenyewa,
    ParamsGetRoomCoWork,
    ParamsGetRoomCoWorkExclusive,
    ParamsGetUkm,
} from "../../constants/types";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";

import LaporanCoWork from "../../components/LaporanCoWork/LaporanCoWork";

import CardListRoom from "../../components/CardListRoom/CardListRoom";
import CardRoom from "../../components/CardRoom/CardRoom";

import CardListRoomKhusus from "../../components/CardListRoomKhusus/CardListRoomKhusus";
import CardRoomKhusus from "../../components/CardRoomKhusus/CardRoomKhusus";

import ModalTambahRuangan from "../../components/ModalTambahRuangan/ModalTambahRuangan";
import ModalTambahRuanganKhusus from "../../components/ModalTambahRuanganKhusus/ModalTambahRuanganKhusus";

import ModalHistoryPenyewa from "../../components/ModalHistoryPenyewa/ModalHistoryPenyewa";
import ModalTambahInvoice from "../../components/ModalTambahInvoice/ModalTambahInvoice";
import ModalTambahPenyewa from "../../components/ModalTambahPenyewa/ModalTambahPenyewa";

import { Delete, Edit } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import ModalDeleteInvoicePenyewa from "../../components/ModalDeleteInvoicePenyewa/ModalDeleteInvoicePenyewa";
import ModalDeletePenyewa from "../../components/ModalDeletePenyewa/ModalDeletePenyewa";
import SyncIcon from '@mui/icons-material/Sync';

import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HistoryIcon from "@mui/icons-material/History";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "../../services/axios";
import toRupiah from "../../utils/toRupiah";

import useRoomCoWork from "../../services/queries/useRoomCoWork";
import useRoomCoWorkExclusive from "../../services/queries/useRoomCoWorkExclusive";

import { mdiCash } from "@mdi/js";
import Icon from "@mdi/react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import CircularProgress from "@mui/material/CircularProgress";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ModifierArguments } from "@popperjs/core";
import Swal from "sweetalert2";
import AscDescIcon from "../../components/AscDescIcon/AscDescIcon";
import LoadingTabel from "../../components/LoadingTabel/LoadingTabel";
import NoRowsImage from "../../components/NoRowsImage/NoRowsImage";
import useInvoicePenyewa from "../../services/queries/useInvoicePenyewa";
import useListPenyewa from "../../services/queries/useListPenyewa";

import ViewListIcon from "@mui/icons-material/ViewList";
import WindowIcon from "@mui/icons-material/Window";

import { SelectChangeEvent } from "@mui/material/Select";
import qs from "query-string";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ModalPindahRuangInvoice from "../../components/ModalPindahRuangInvoice/ModalPindahRuangInvoice";
import "moment/locale/id";

type DateFilter = [Date | null, Date | null];

interface ICoworkingProps {}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ paddingY: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function hexToRgb(hex: string | undefined): string {
    if (!hex) return "255, 255, 255";

    hex = hex.replace(/^#/, "");

    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    const num = parseInt(hex, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;

    return `${r}, ${g}, ${b}`;
}

interface IDataDeletePenyewa {
    idPenyewa: string;
    namaPenyewa: string;
}

interface IDataHistoryPenyewa {
    idPenyewa: string;
    namaPenyewa: string;
}

interface IDataDeleteInvoicePenyewa {
    idInvoicePenyewa: string;
    noInvoice: string;
}

const Coworking = (props: ICoworkingProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const moment = require("moment");
    let now = moment().format("YYYY-MM-DD");

    const today = new Date();

    function subtractYears(numOfYears: number, date = new Date()) {
        date.setFullYear(date.getFullYear() - numOfYears);

        return date;
    }

    const [value, setValue] = React.useState(0);
    const { status: statusUser, data: user } = useUser();

    const [menuState, setMenuState] = useState<{
        anchorEl: HTMLElement | null;
        rowId: number | null;
    }>({
        anchorEl: null,
        rowId: null,
    });

    const handleClick = (
        event: React.MouseEvent<HTMLButtonElement>,
        rowId: number,
    ) => {
        setMenuState({
            anchorEl: event.currentTarget,
            rowId,
        });
    };

    const handleClose = () => {
        setMenuState({
            anchorEl: null,
            rowId: null,
        });
    };

    const openAction = Boolean(menuState.anchorEl);

    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsUkm, setParamsUkm] =
        React.useState<ParamsGetUkm>(initialParamsUkm);
    const { data: ukm } = useUkm(paramsUkm);

    // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    //     setValue(newValue);
    // };

    const [loadedTabs, setLoadedTabs] = useState<{
        ruangan: boolean;
        ruanganKhusus: boolean;
        penyewa: boolean;
        pemakaian: boolean;
    }>({
        ruangan: true,
        ruanganKhusus: false,
        penyewa: false,
        pemakaian: false,
    });

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukmId, ukm]);

    React.useEffect(() => {
        if (user && user?.ukmId?.length > 0) {
            setParamsUkm((prev) => ({
                ...prev,
                userId: user.ukmId[0],
            }));
        }
    }, [user]);

    const initialParamsGetListRoom = {
        size: 9,
        page: 1,
        search: "",
        status: "Semua",
    };

    const [paramsListRoom, setParamsListRoom] = useState<ParamsGetRoomCoWork>(
        initialParamsGetListRoom,
    );

    const [isCardView, setIsCardView] = useState(true);

    const handleCardView = useCallback(() => setIsCardView(true), []);
    const handleListView = useCallback(() => setIsCardView(false), []);

    const [isCardViewKhusus, setIsCardViewKhusus] = useState(true);

    const handleCardViewKhusus = useCallback(
        () => setIsCardViewKhusus(true),
        [],
    );
    const handleListViewKhusus = useCallback(
        () => setIsCardViewKhusus(false),
        [],
    );

    const [search, setSearch] = useState<string>("");

    const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    const handleSearch = () => {
        setParamsListRoom((prev) => ({
            ...prev,
            search: search,
        }));
    };

    const {
        data: listRoom,
        isLoading: isLoadingListRoom,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useRoomCoWork(paramsListRoom, {
        enabled: loadedTabs.ruangan,
    });

    // const totalRooms = listRoom?.pages?.[0]?.results?.totalAll ?? 0;

    const initialParamsGetListRoomExclusive = {
        size: 9,
        page: 1,
        search: "",
        status: "Semua",
    };

    const [paramsListRoomExclusive, setParamsListRoomExclusive] =
        useState<ParamsGetRoomCoWorkExclusive>(
            initialParamsGetListRoomExclusive,
        );

    const [searchExclusive, setSearchExclusive] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    const handleChangeSearchExclusive = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setSearchExclusive(event.target.value);
    };

    const handleSearchExclusive = () => {
        setParamsListRoomExclusive((prev) => ({
            ...prev,
            search: search,
        }));
    };

    const {
        data: listRoomExclusive,
        isLoading: isLoadingListRoomExclusive,
        fetchNextPage: fetchNextPageExclusive,
        hasNextPage: hasNextPageExclusive,
        isFetchingNextPage: isFetchingNextPageExclusive,
    } = useRoomCoWorkExclusive(paramsListRoomExclusive, {
        enabled: loadedTabs.ruanganKhusus,
    });

    // const totalRoomsExclusive = listRoomExclusive?.pages?.[0]?.results?.totalAll ?? 0;

    const [isOpenModalTambahRuangan, setIsOpenModalTambahRuangan] =
        React.useState(false);

    const openModalTambahRuangan = () => {
        setIsOpenModalTambahRuangan(true);
    };
    const closeModalTambahRuangan = () => setIsOpenModalTambahRuangan(false);

    const [isOpenModalTambahRuanganKhusus, setIsOpenModalTambahRuanganKhusus] =
        React.useState(false);

    const openModalTambahRuanganKhusus = () => {
        setIsOpenModalTambahRuanganKhusus(true);
    };
    const closeModalTambahRuanganKhusus = () =>
        setIsOpenModalTambahRuanganKhusus(false);

    const [dateRange, setDateRange] = React.useState<DateFilter>([
        new Date(),
        new Date(),
    ]);
    const [startDate, endDate] = dateRange;

    const handleChangePeriode = (event: SelectChangeEvent) => {
        setDateRange([new Date(event.target.value), new Date()]);
        setParamsListPenyewa((prev) => ({
            ...prev,
            tanggalAwal: String(event.target.value),
            tanggalAkhir: now,
            page: 1,
        }));

        refetchListPenyewa();
    };

    const handleChangeJangkaWaktu = (
        tanggalAwal: string,
        tanggalAkhir: string,
    ) => {
        setParamsListPenyewa((prev) => ({
            ...prev,
            tanggalAwal: tanggalAwal,
            tanggalAkhir: tanggalAkhir,
            page: 1,
        }));

        refetchListPenyewa();
    };

    const downloadData = async () => {
        setIsLoading(true);
        try {
            const api = qs.stringifyUrl({
                url: "api/mpenyewas/export",
                // query: {
                //     ukmId: ukmId,
                //     tanggalAwal: paramsListPenyewa.tanggalAwal,
                //     tanggalAkhir: paramsListPenyewa.tanggalAkhir,
                // },
            });
            const { data } = await axios.get(api, {
                responseType: "blob",
            });
            const file = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", `Data_Penyewa`);
            document.body.appendChild(link);
            link.click();
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Terjadi Kesalahan!",
                position: "top-end",
                showConfirmButton: false,
                icon: "error",
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                showCloseButton: true,
                customClass: {
                    container: "my-swal",
                },
            });
        }
    };

    const [isOpenModalHistoryPenyewa, setIsOpenModalHistoryPenyewa] =
        React.useState(false);

    const [isOpenModalTambahPenyewa, setIsOpenModalTambahPenyewa] =
        React.useState(false);

    const [isOpenModalDeletePenyewa, setIsOpenModalDeletePenyewa] =
        React.useState(false);

    const initialParamsGetListPenyewa = {
        size: 10,
        page: 1,
        search: "",
        status: "semua",
        tanggalAwal: now,
        tanggalAkhir: now,
    };

    const [paramsListPenyewa, setParamsListPenyewa] =
        useState<ParamsGetListPenyewa>(initialParamsGetListPenyewa);

    const [searchPenyewa, setSearchPenyewa] = useState<string>("");

    const handleChangeSearchPenyewa = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setSearchPenyewa(event.target.value);
    };

    const handleSearchPenyewa = () => {
        setParamsListPenyewa((prev) => ({
            ...prev,
            search: searchPenyewa,
        }));
    };

    const {
        data: listPenyewa,
        isLoading: isLoadingListPenyewa,
        refetch: refetchListPenyewa,
    } = useListPenyewa(paramsListPenyewa, {
        enabled: loadedTabs.penyewa,
    });

    const initialParamsGetListInvoicePenyewa = {
        size: 10,
        page: 1,
        search: "",
        status: "Semua",
        tanggalAwal: now,
        tanggalAkhir: now,
    };

    const [paramsListInvoicePenyewa, setParamsListInvoicePenyewa] =
        useState<ParamsGetListInvoicePenyewa>(
            initialParamsGetListInvoicePenyewa,
        );

    const [searchInvoicePenyewa, setSearchInvoicePenyewa] =
        useState<string>("");

    const handleChangeSearchInvoicePenyewa = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setSearchInvoicePenyewa(event.target.value);
    };

    const handleSearchInvoicePenyewa = () => {
        setParamsListInvoicePenyewa((prev) => ({
            ...prev,
            search: searchInvoicePenyewa,
        }));
    };

    const {
        data: listInvoicePenyewa,
        isLoading: isLoadingListInvoicePenyewa,
        refetch: refetchListInvoicePenyewa,
    } = useInvoicePenyewa(paramsListInvoicePenyewa, {
        enabled: loadedTabs.pemakaian,
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);

        switch (newValue) {
            case 0:
                break;

            case 1:
                if (!loadedTabs.ruanganKhusus) {
                    setLoadedTabs((prev) => ({ ...prev, ruanganKhusus: true }));
                }
                break;

            case 2:
                if (!loadedTabs.penyewa) {
                    setLoadedTabs((prev) => ({ ...prev, penyewa: true }));
                }
                break;

            case 3:
                if (!loadedTabs.pemakaian) {
                    setLoadedTabs((prev) => ({ ...prev, pemakaian: true }));
                }
                break;
        }
    };

    const [dateRangeListInvoice, setDateRangeListInvoice] =
        React.useState<DateFilter>([new Date(), new Date()]);
    const [startDateListInvoice, endDateListInvoice] = dateRangeListInvoice;

    const handleChangePeriodeListInvoice = (event: SelectChangeEvent) => {
        const selectedValue = event.target.value;

        if (selectedValue === "all") {
            setParamsListInvoicePenyewa((prev) => ({
                ...prev,
                tanggalAwal: "",
                tanggalAkhir: "",
                page: 1,
            }));
            setDateRangeListInvoice([null, null]);
        } else {
            setDateRangeListInvoice([new Date(selectedValue), new Date()]);
            setParamsListInvoicePenyewa((prev) => ({
                ...prev,
                tanggalAwal: String(selectedValue),
                tanggalAkhir: now,
                page: 1,
            }));
        }

        refetchListInvoicePenyewa();
    };

    const handleChangeJangkaWaktuListInvoice = (
        tanggalAwal: string,
        tanggalAkhir: string,
    ) => {
        setParamsListInvoicePenyewa((prev) => ({
            ...prev,
            tanggalAwal: tanggalAwal,
            tanggalAkhir: tanggalAkhir,
            page: 1,
        }));

        refetchListInvoicePenyewa();
    };

    const getSelectValue = () => {
        const { tanggalAwal, tanggalAkhir } = paramsListInvoicePenyewa;

        if (!tanggalAwal && !tanggalAkhir) {
            return "all";
        }

        if (
            tanggalAwal === now ||
            tanggalAwal === moment().subtract(7, "days").format("YYYY-MM-DD") ||
            tanggalAwal ===
                moment().subtract(1, "month").format("YYYY-MM-DD") ||
            tanggalAwal ===
                moment().subtract(3, "months").format("YYYY-MM-DD") ||
            tanggalAwal === moment().subtract(1, "years").format("YYYY-MM-DD")
        ) {
            return tanggalAwal;
        }

        return "Custom";
    };

    const downloadDataListInvoice = async () => {
        setIsLoading(true);
        try {
            const api = qs.stringifyUrl({
                url: "api/invoice-sewa/export",
                query: {
                    ukmId: ukmId,
                    tanggalMulai: paramsListInvoicePenyewa.tanggalAwal,
                    tanggalAkhir: paramsListInvoicePenyewa.tanggalAkhir,
                },
            });
            const { data } = await axios.get(api, {
                responseType: "blob",
            });
            const file = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", `Data_Pemakaian`);
            document.body.appendChild(link);
            link.click();
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Terjadi Kesalahan!",
                position: "top-end",
                showConfirmButton: false,
                icon: "error",
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                showCloseButton: true,
                customClass: {
                    container: "my-swal",
                },
            });
        }
    };

    // useEffect(() => {
    //     if (listPenyewa && loadingTabs.penyewa) {
    //         setLoadingTabs(prev => ({ ...prev, penyewa: false }));
    //     }
    // }, [listPenyewa, loadingTabs.penyewa]);

    // useEffect(() => {
    //     if (listInvoicePenyewa && loadingTabs.invoice) {
    //         setLoadingTabs(prev => ({ ...prev, invoice: false }));
    //     }
    // }, [listInvoicePenyewa, loadingTabs.invoice]);

    const [dataDeleteInvoicePenyewa, setDataDeleteInvoicePenyewa] =
        React.useState<IDataDeleteInvoicePenyewa>();

    const [
        isOpenModalDeleteInvoicePenyewa,
        setIsOpenModalDeleteInvoicePenyewa,
    ] = React.useState(false);

    const openModalDeleteInvoicePenyewa = () =>
        setIsOpenModalDeleteInvoicePenyewa(true);

    const closeModalDeleteInvoicePenyewa = () => {
        setIsOpenModalDeleteInvoicePenyewa(false);
        refetchListInvoicePenyewa();
    };

    const [dataHistoryPenyewa, setDataHistoryPenyewa] =
        React.useState<IDataHistoryPenyewa>();

    const [dataPenyewa, setDataPenyewa] = React.useState<AddPenyewaCoWork>();

    const [dataDeletePenyewa, setDataDeletePenyewa] =
        React.useState<IDataDeletePenyewa>();

    const openModalHistoryPenyewa = () => setIsOpenModalHistoryPenyewa(true);

    const closeModalHistoryPenyewa = () => setIsOpenModalHistoryPenyewa(false);

    const openModalTambahPenyewa = (dataPenyewa?: AddPenyewaCoWork) => {
        setDataPenyewa(dataPenyewa);
        setIsOpenModalTambahPenyewa(true);
    };
    const closeModalTambahPenyewa = () => setIsOpenModalTambahPenyewa(false);

    const openModalDeletePenyewa = () => setIsOpenModalDeletePenyewa(true);
    const closeModalDeletePenyewa = () => setIsOpenModalDeletePenyewa(false);

    const handleOnPagination = (page: number) => {
        setParamsListPenyewa((prev) => ({
            ...prev,
            page: page + 1,
        }));
    };

    const handleOnSizeChange = (size: number) => {
        setParamsListPenyewa((prev) => ({ ...prev, size }));
    };

    const handleOnPaginationListInvoicePenyewa = (page: number) => {
        setParamsListInvoicePenyewa((prev) => ({
            ...prev,
            page: page + 1,
        }));
    };

    const handleOnSizeChangeListInvoicePenyewa = (size: number) => {
        setParamsListInvoicePenyewa((prev) => ({ ...prev, size }));
    };

    const columns: GridColDef[] = [
        {
            field: "namaPerusahaan",
            headerName: "Nama Perusahaan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 250,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "nomorTelepon",
            headerName: "No Telepon",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "npwpPerusahaan",
            headerName: "NPWP Perusahaan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value || "-"}>
                    <span className="table-cell-trucate">
                        {params.value || "-"}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "alamat",
            headerName: "Alamat Perusahaan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "namaPic",
            headerName: "Nama PIC",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "npwpPic",
            headerName: "NPWP PIC",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value || "-"}>
                    <span className="table-cell-trucate">
                        {params.value || "-"}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "noKtpPic",
            headerName: "No KTP PIC",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value || "-"}>
                    <span className="table-cell-trucate">
                        {params.value || "-"}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "nomorTeleponPic",
            headerName: "No Telp PIC",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "alamatPic",
            headerName: "Alamat PIC",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },

        {
            field: "status",
            headerName: "Status",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => {
                const capitalizeWords = (text: string) =>
                    text
                        ? text
                              .split(" ")
                              .map(
                                  (w) => w.charAt(0).toUpperCase() + w.slice(1),
                              )
                              .join(" ")
                        : "";

                return (
                    <Tooltip title={params.value}>
                        <span className="table-cell-trucate">
                            {capitalizeWords(params.value)}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tanggalDibuat",
            headerName: "Tanggal Dibuat",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => {
                const formattedDate = moment(params.value).format(
                    "D MMMM YYYY",
                );

                return (
                    <Tooltip title={formattedDate}>
                        <span className="table-cell-trucate">
                            {formattedDate}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "ukm",
            headerName: "UKM",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 150,
            renderCell: (params) => (
                <Tooltip title={params.value.nama ?? "-"}>
                    <span className="table-cell-trucate">
                        {params.value.nama ?? "-"}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "aksi",
            headerName: "Aksi",
            align: "left",
            minWidth: 160,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const row: DataPenyewa = params.row;
                return (
                    <Stack direction="row" spacing={1}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setDataHistoryPenyewa({
                                    idPenyewa: params.row.id,
                                    namaPenyewa: params.row.namaPerusahaan,
                                });
                                openModalHistoryPenyewa();
                            }}
                            size="small"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                                backgroundColor: "#0A5BBB",
                            }}
                        >
                            <HistoryIcon
                                sx={{ width: "16px", height: "16px" }}
                            />
                        </Button>

                        <Button
                            variant="contained"
                            onClick={() =>
                                openModalTambahPenyewa({
                                    id: row.id,
                                    ukmId: row.ukm.id,
                                    namaPerusahaan: row.namaPerusahaan,
                                    nomorTelepon: row.nomorTelepon,
                                    alamat: row.alamat,
                                    namaPic: row.namaPic,
                                    nomorTeleponPic: row.nomorTeleponPic,
                                    alamatPic: row.alamatPic,
                                    npwpPerusahaan: row.npwpPerusahaan,
                                    npwpPic: row.npwpPic,
                                    noKtpPic: row.noKtpPic,
                                })
                            }
                            size="small"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                                backgroundColor: "#2B7351",
                            }}
                        >
                            <Edit sx={{ width: "16px", height: "16px" }} />
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setDataDeletePenyewa({
                                    idPenyewa: params.row.id,
                                    namaPenyewa: params.row.namaPerusahaan,
                                });
                                openModalDeletePenyewa();
                            }}
                            size="small"
                            color="buttonred"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <Delete sx={{ width: "16px", height: "16px" }} />
                        </Button>
                    </Stack>
                );
            },
        },
    ];

    const [loadingActions, setLoadingActions] = useState<
        Record<number, boolean>
    >({});

    const columnsListInvoicePenyewa: GridColDef[] = [
        {
            field: "noInvoice",
            headerName: "No. Invoice",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 250,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "namaPerusahaan",
            headerName: "Perusahaan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 250,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "ruangan",
            headerName: "Ruangan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 250,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "kategori",
            headerName: "Kategori",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 150,
            renderCell: (params) => {
                const isBiasa = params.value === 0;
                const kategoriText = isBiasa ? "Biasa" : "Khusus";

                return (
                    <Tooltip title={kategoriText}>
                        <span className="table-cell-trucate">
                            {kategoriText}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tanggalMulai",
            headerName: "Awal Sewa",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => {
                if (!params.value) {
                    return "-";
                }

                const formattedDate = moment(params.value).format(
                    "D MMMM YYYY",
                );
                const formattedTime = moment(params.value).format("HH:mm");

                return (
                    <Tooltip title={`${formattedDate} ${formattedTime}`}>
                        <span className="table-cell-trucate">
                            {formattedDate} {formattedTime}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tanggalBerakhir",
            headerName: "Akhir Sewa",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => {
                if (!params.value) {
                    return "-";
                }

                const formattedDate = moment(params.value).format(
                    "D MMMM YYYY",
                );
                const formattedTime = moment(params.value).format("HH:mm");

                return (
                    <Tooltip title={`${formattedDate} ${formattedTime}`}>
                        <span className="table-cell-trucate">
                            {formattedDate} {formattedTime}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tagihan",
            headerName: "Tagihan",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 180,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">
                        {toRupiah(params.value)}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "jatuhTempo",
            headerName: "Jatuh Tempo",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="table-cell-trucate">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "status",
            headerName: "Status",
            flex: isPhoneScreen ? undefined : 1.5,
            minWidth: 200,
            renderCell: (params) => {
                const status = params.value;
                let backgroundColor = "";
                let textColor = "";
                let displayText = "";

                switch (status.toLowerCase()) {
                    case "unpaid":
                        backgroundColor = "#ED4521";
                        textColor = "white";
                        displayText = "Unpaid";
                        break;
                    case "paid":
                        backgroundColor = "#119C5B";
                        textColor = "white";
                        displayText = "Paid";
                        break;
                    case "sent":
                        backgroundColor = "#DCF6EA";
                        textColor = "black";
                        displayText = "Sent";
                        break;
                    case "booked":
                        backgroundColor = "#0A5BBB";
                        textColor = "white";
                        displayText = "Booked";
                        break;
                    default:
                        backgroundColor = "grey";
                        textColor = "white";
                        displayText = status;
                }

                return (
                    <Box
                        sx={{
                            backgroundColor,
                            color: textColor,
                            padding: "8px 12px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            textAlign: "center",
                        }}
                    >
                        {displayText}
                    </Box>
                );
            },
        },
        {
            field: "aksi",
            headerName: "Aksi",
            align: "left",
            minWidth: 160,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const row = params.row;
                const isUnpaid = row.status?.toLowerCase() === "unpaid";
                const isPaid = row.status?.toLowerCase() === "paid";
                const isLoading = loadingActions[row.id] || false;

                const handleKonfirmasiPembayaran = async () => {
                    setLoadingActions((prev) => ({ ...prev, [row.id]: true }));

                    try {
                        await axios.post(`/api/invoice-sewa/${row.id}/status`, {
                            action: "paid",
                        });
                        console.log("Status updated: paid");
                        Swal.fire({
                            title: "Berhasil!",
                            text: "Pembayaran berhasil dikonfirmasi",
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });

                        refetchListInvoicePenyewa();
                    } catch (error) {
                        console.error("Error update status:", error);
                        Swal.fire({
                            title: "Gagal mengkonfirmasi pembayaran",
                            text: "Terjadi kesalahan saat mengkonfirmasi pembayaran",
                            icon: "error",
                        });
                    } finally {
                        setLoadingActions((prev) => ({
                            ...prev,
                            [row.id]: false,
                        }));
                        handleClose();
                    }
                };

                const handleBatalKonfirmasiPembayaran = async () => {
                    setLoadingActions((prev) => ({ ...prev, [row.id]: true }));

                    try {
                        await axios.post(`/api/invoice-sewa/${row.id}/status`, {
                            action: "unpaid",
                        });
                        console.log("Status updated: paid");
                        Swal.fire({
                            title: "Berhasil!",
                            text: "Pembayaran berhasil batal dikonfirmasi",
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });

                        refetchListInvoicePenyewa();
                    } catch (error) {
                        console.error("Error update status:", error);
                        Swal.fire({
                            title: "Gagal mengkonfirmasi batal pembayaran",
                            text: "Terjadi kesalahan saat mengkonfirmasi pembayaran",
                            icon: "error",
                        });
                    } finally {
                        setLoadingActions((prev) => ({
                            ...prev,
                            [row.id]: false,
                        }));
                        handleClose();
                    }
                };

                const handlePrint = async () => {
                    try {
                        const response = await axios.get(
                            `/api/invoice/${row.id}/print`,
                            {
                                responseType: "blob",
                            },
                        );

                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data]),
                        );
                        const link = document.createElement("a");
                        link.href = fileURL;
                        link.setAttribute(
                            "download",
                            `invoice-${row.noInvoice || row.id}.pdf`,
                        );
                        document.body.appendChild(link);
                        link.click();
                        link.remove();

                        Swal.fire({
                            title: "Berhasil!",
                            text: "Invoice berhasil diunduh",
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });
                    } catch (error) {
                        console.error("Error printing invoice:", error);
                        Swal.fire({
                            title: "Gagal mencetak invoice",
                            text: "Terjadi kesalahan saat mencetak invoice",
                            icon: "error",
                        });
                    } finally {
                        setLoadingActions((prev) => ({
                            ...prev,
                            [row.id]: false,
                        }));
                        handleClose();
                    }
                };

                return (
                    <Stack direction="row" spacing={1}>
                        <IconButton
                            sx={{
                                bgcolor: "primary.main",
                                borderRadius: "8px",
                                "&:hover": { backgroundColor: "primary.main" },
                            }}
                            onClick={(e) => handleClick(e, row.id)}
                            aria-controls={
                                openAction ? "basic-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={openAction ? "true" : undefined}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                />
                            ) : (
                                <MoreVertIcon
                                    fontSize="small"
                                    sx={{ color: "white" }}
                                />
                            )}
                        </IconButton>

                        <Menu
                            id="basic-menu"
                            anchorEl={menuState.anchorEl}
                            open={openAction && menuState.rowId === row.id}
                            onClose={handleClose}
                            MenuListProps={{
                                "aria-labelledby": "basic-button",
                            }}
                            PaperProps={{ style: { width: "200px" } }}
                        >
                            {/* Hanya tampilkan Konfirmasi untuk status unpaid */}
                            {isUnpaid && (
                                <MenuItem
                                    onClick={handleKonfirmasiPembayaran}
                                    disabled={isLoading}
                                >
                                    <ListItemIcon>
                                        {isLoading ? (
                                            <CircularProgress size={16} />
                                        ) : (
                                            <Icon path={mdiCash} size={1} />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText>
                                        {isLoading
                                            ? "Memproses..."
                                            : "Konfirmasi"}
                                    </ListItemText>
                                </MenuItem>
                            )}

                            {isPaid && (
                                <MenuItem
                                    onClick={handleBatalKonfirmasiPembayaran}
                                    disabled={isLoading}
                                >
                                    <ListItemIcon>
                                        {isLoading ? (
                                            <CircularProgress size={16} />
                                        ) : (
                                            <Icon path={mdiCash} size={1} />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText>
                                        {isLoading
                                            ? "Memproses..."
                                            : "Unconfirmed"}
                                    </ListItemText>
                                </MenuItem>
                            )}

                            {isPaid && (
                                <MenuItem 
                                    onClick={() => {
                                        openModalPindahRuanganInvoice({
                                            id: row.id,
                                            penyewaId: row.penyewaId,
                                            ruanganId: row.ruanganId,
                                            noInvoice: row.noInvoice,
                                            namaPerusahaan: row.namaPerusahaan,
                                            ruangan: row.ruangan,
                                            jenisSewa: row.jenisSewa,
                                            tanggalMulai: row.tanggalMulai,
                                            tanggalBerakhir: row.tanggalBerakhir,
                                            tipeHarga: row.tipeHarga,
                                            nominal: row.tagihanBulanan,
                                            keterangan: row.keterangan,
                                            periodeMingguan: row.periodeMingguan,
                                        });
                                        handleClose();
                                    }}
                                    disabled={isLoading}
                                >
                                    <ListItemIcon>
                                        {isLoading ? (
                                            <CircularProgress size={16} />
                                        ) : (
                                            <SyncIcon fontSize="small" />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText>
                                        {isLoading ? "Memproses..." : "Pindah"}
                                    </ListItemText>
                                </MenuItem>
                            )}

                            {/* Print selalu tersedia */}
                            <MenuItem onClick={handlePrint}>
                                <ListItemIcon>
                                    <LocalPrintshopIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Print</ListItemText>
                            </MenuItem>

                            {/* Edit hanya untuk unpaid */}
                            {isUnpaid && (
                                <MenuItem
                                    onClick={() => {
                                        openModalTambahInvoice({
                                            id: row.id,
                                            penyewaId: row.penyewaId,
                                            ruanganId: row.ruanganId,
                                            tanggalMulai: row.tanggalMulai,
                                            tanggalBerakhir: row.tanggalBerakhir,
                                            tipeHarga: row.tipeHarga,
                                            nominal: row.tagihanBulanan,
                                            keterangan: row.keterangan,
                                            jenisSewa: row.jenisSewa,
                                            periodeMingguan: row.periodeMingguan,
                                        });
                                        handleClose();
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Edit</ListItemText>
                                </MenuItem>
                            )}

                            {isPaid && (
                                <MenuItem
                                    onClick={() => {
                                        openModalTambahInvoice({
                                            id: row.id,
                                            penyewaId: row.penyewaId,
                                            ruanganId: row.ruanganId,
                                            tanggalMulai: row.tanggalMulai,
                                            tanggalBerakhir:
                                                row.tanggalBerakhir,
                                            tipeHarga: row.tipeHarga,
                                            nominal: row.tagihanBulanan,
                                            keterangan: row.keterangan,
                                            jenisSewa: row.jenisSewa,
                                            periodeMingguan: row.periodeMingguan,
                                            isReadOnly: true,
                                        });
                                        handleClose();
                                    }}
                                >
                                    <ListItemIcon>
                                        <VisibilityIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Detail Invoice</ListItemText>
                                </MenuItem>
                            )}

                            {/* Hapus hanya untuk unpaid */}
                            {isUnpaid && (
                                <MenuItem
                                    onClick={() => {
                                        setDataDeleteInvoicePenyewa({
                                            idInvoicePenyewa: params.row.id,
                                            noInvoice: params.row.noInvoice,
                                        });
                                        openModalDeleteInvoicePenyewa();
                                    }}
                                >
                                    <ListItemIcon>
                                        <DeleteIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Hapus</ListItemText>
                                </MenuItem>
                            )}
                        </Menu>
                    </Stack>
                );
            },
        },
    ];

    const [dataInvoice, setDataInvoice] = React.useState<IDataTambahInvoice>();

    const [isOpenModalTambahInvoice, setIsOpenModalTambahInvoice] =
        React.useState(false);

    const openModalTambahInvoice = (dataInvoice?: IDataTambahInvoice) => {
        setDataInvoice(dataInvoice);
        setIsOpenModalTambahInvoice(true);
    };

    const closeModalTambahInvoice = () => {
        setIsOpenModalTambahInvoice(false);
        refetchListInvoicePenyewa();
    };

    const [isOpenModalPindahRuanganInvoice, setIsOpenModalPindahRuanganInvoice] =
        React.useState(false);

    const openModalPindahRuanganInvoice = (
        dataInvoice?: IDataTambahInvoice,
    ) => {
        setDataInvoice(dataInvoice);
        setIsOpenModalPindahRuanganInvoice(true);
    };

    const closeModalPindahRuanganInvoice = () => {
        setIsOpenModalPindahRuanganInvoice(false);
        refetchListInvoicePenyewa();
    };

    if (statusUser === "loading") {
        return (
            <Stack
                display="grid"
                gridTemplateColumns="1fr"
                alignItems="center"
                height="100vh"
                position="relative"
            >
                <Spinner />
            </Stack>
        );
    }

    return (
        <React.Fragment>
            {/* <Typography fontWeight="bold" variant="h5" sx={{ marginY: 2 }}>
                Coworking
            </Typography> */}

            <Box>
                <Box mt={2}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="basic tabs example"
                    >
                        <Tab label="Daftar Ruangan" {...a11yProps(0)} />
                        <Tab label="Daftar Ruangan Khusus" {...a11yProps(1)} />
                        <Tab label="Daftar Penyewa" {...a11yProps(2)} />
                        <Tab label="Daftar Pemakaian" {...a11yProps(3)} />
                        <Tab label="Laporan Co Work" {...a11yProps(4)} />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <Stack
                        direction={{
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "row",
                        }}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                        marginY={2}
                    >
                        <Typography fontWeight="bold" fontSize={30}>
                            Daftar Ruangan
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1.5}
                            justifyContent="end"
                            display="flex"
                            alignItems="center"
                        >
                            <Typography>
                                Jumlah Ruangan:{" "}
                                {isLoadingListRoom ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span style={{ fontWeight: "bold" }}>
                                        {listRoom?.pages?.[0]?.results
                                            ?.totalAll ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Ruangan Terpakai:{" "}
                                {isLoadingListRoom ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#0A5BBB",
                                        }}
                                    >
                                        {listRoom?.pages?.[0]?.results
                                            ?.totalTerpakai ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Ruangan Tidak Terpakai:{" "}
                                {isLoadingListRoom ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#119C5B",
                                        }}
                                    >
                                        {listRoom?.pages?.[0]?.results
                                            ?.totalTidakTerpakai ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                size="large"
                                sx={{ width: "fit-content" }}
                                onClick={() => openModalTambahRuangan()}
                                data-testid="tambah-ruangan"
                            >
                                Tambah Ruangan
                            </Button>
                        </Stack>
                    </Stack>

                    <Stack
                        direction="row"
                        display="flex"
                        justifyContent="space-between"
                        mt={3}
                    >
                        <Stack
                            direction={{ xs: "row" }}
                            alignItems="center"
                            spacing={2}
                        >
                            <TextField
                                placeholder="Cari"
                                size="medium"
                                value={search}
                                onChange={handleChangeSearch}
                                onKeyPress={(e) => {
                                    const element =
                                        e.target as HTMLInputElement;
                                    if (e.key === "Enter") {
                                        setParamsListRoom((prev) => ({
                                            ...prev,
                                            search: element.value,
                                            page: 1,
                                        }));
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleSearch}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                            />

                            <FormControl size="medium" sx={{ width: "50%" }}>
                                <InputLabel id="demo-simple-select-helper-label">
                                    Kategori Ruangan
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    label="Kategori Ruangan"
                                    defaultValue="Semua"
                                    onChange={(e) =>
                                        setParamsListRoom((prev) => ({
                                            ...prev,
                                            status: String(e.target.value),
                                        }))
                                    }
                                >
                                    <MenuItem value="Semua">
                                        Semua Ruangan
                                    </MenuItem>
                                    <MenuItem value="Tersedia">
                                        Tersedia
                                    </MenuItem>
                                    <MenuItem value="Disewa">Disewa</MenuItem>
                                    <MenuItem value="Akan Berakhir">
                                        Akan Berakhir
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>

                        <Stack
                            direction="row"
                            spacing={2}
                            marginTop={3}
                            marginBottom={1}
                            alignItems="center"
                            // display={
                            //     isPhoneScreen || isTabletScreen ? "none" : undefined
                            // }
                        >
                            <Button
                                // size="small"
                                variant={isCardView ? "contained" : "outlined"}
                                onClick={handleCardView}
                                sx={{
                                    padding: "10px",
                                }}
                            >
                                <WindowIcon />
                            </Button>

                            <Button
                                // size="small"
                                variant={isCardView ? "outlined" : "contained"}
                                onClick={handleListView}
                                sx={{
                                    padding: "10px",
                                }}
                            >
                                <ViewListIcon />
                            </Button>
                        </Stack>
                    </Stack>

                    <Stack
                        position="relative"
                        spacing={1}
                        mt={4}
                        height={`calc(100vh - 182px)`}
                        overflow="auto"
                    >
                        {!loadedTabs.ruangan ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height={300}
                            >
                                <CircularProgress size={40} />
                                <Typography sx={{ ml: 2 }}>
                                    Memuat data ruangan...
                                </Typography>
                            </Box>
                        ) : isLoadingListRoom ? (
                            <Spinner />
                        ) : listRoom ? (
                            <React.Fragment>
                                {listRoom.pages[0].results.totalElements ===
                                0 ? (
                                    <Box
                                        display="flex"
                                        flex={1}
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                        height="100%"
                                    >
                                        <MeetingRoomIcon
                                            sx={{
                                                textAlign: "center",
                                                color: "primary",
                                                fontSize: "50px",
                                                padding: 1,
                                                borderRadius: "100%",
                                                backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                            }}
                                        />
                                        <Typography
                                            fontWeight={600}
                                            fontSize={25}
                                            textAlign="center"
                                            mt={2}
                                        >
                                            Ruangan Tidak ditemukan
                                        </Typography>
                                    </Box>
                                ) : (
                                    <>
                                        {isCardView ? (
                                            // Grid View (Card View) - Default
                                            <Grid container spacing={2}>
                                                {listRoom.pages.map(
                                                    (page, pageIndex) =>
                                                        page.results.content.map(
                                                            (li) => (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={4}
                                                                    key={`${pageIndex}-${li.id}`}
                                                                >
                                                                    <CardRoom
                                                                        data={
                                                                            li
                                                                        }
                                                                    />
                                                                </Grid>
                                                            ),
                                                        ),
                                                )}
                                            </Grid>
                                        ) : (
                                            // List View
                                            <Grid container spacing={2}>
                                                {listRoom.pages.map(
                                                    (page, pageIndex) =>
                                                        page.results.content.map(
                                                            (li) => (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    key={`${pageIndex}-${li.id}`}
                                                                >
                                                                    <CardListRoom
                                                                        data={
                                                                            li
                                                                        }
                                                                    />
                                                                </Grid>
                                                            ),
                                                        ),
                                                )}
                                            </Grid>
                                        )}

                                        {hasNextPage && (
                                            <Box width="100%" paddingY={2}>
                                                <LoadingButton
                                                    variant="outlined"
                                                    onClick={() =>
                                                        fetchNextPage()
                                                    }
                                                    loading={isFetchingNextPage}
                                                    loadingPosition="center"
                                                    size="large"
                                                    fullWidth
                                                >
                                                    {hasNextPage
                                                        ? "Muat lebih banyak"
                                                        : "Tidak ada lagi yang bisa dimuat"}
                                                </LoadingButton>
                                            </Box>
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                mt={10}
                            >
                                <MeetingRoomIcon
                                    sx={{
                                        textAlign: "center",
                                        color: "primary",
                                        fontSize: "50px",
                                        padding: 1,
                                        borderRadius: "100%",
                                        backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                    }}
                                />
                                <Typography
                                    fontWeight={600}
                                    fontSize={25}
                                    textAlign="center"
                                >
                                    Ruangan Kosong
                                </Typography>
                                <Typography textAlign="center">
                                    Daftar ruangan kosong silahkan tambahkan
                                    ruangan terlebih dahulu
                                </Typography>
                            </Box>
                        )}
                    </Stack>
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <Stack
                        direction={{
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "row",
                        }}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                        marginY={2}
                    >
                        <Typography fontWeight="bold" fontSize={30}>
                            Daftar Ruangan Khusus
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1.5}
                            justifyContent="end"
                            display="flex"
                            alignItems="center"
                        >
                            <Typography>
                                Jumlah Ruangan Khusus:{" "}
                                {!loadedTabs.ruanganKhusus ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListRoomExclusive ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span style={{ fontWeight: "bold" }}>
                                        {listRoomExclusive?.pages?.[0]?.results
                                            ?.totalAll ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Ruangan Terpakai:{" "}
                                {!loadedTabs.ruanganKhusus ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListRoomExclusive ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#0A5BBB",
                                        }}
                                    >
                                        {listRoomExclusive?.pages?.[0]?.results
                                            ?.totalTerpakai ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Ruangan Tidak Terpakai:{" "}
                                {!loadedTabs.ruanganKhusus ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListRoomExclusive ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#119C5B",
                                        }}
                                    >
                                        {listRoomExclusive?.pages?.[0]?.results
                                            ?.totalTidakTerpakai ?? 0}
                                    </span>
                                )}
                            </Typography>

                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                size="large"
                                sx={{ width: "fit-content" }}
                                onClick={() => openModalTambahRuanganKhusus()}
                                data-testid="tambah-ruangan-khusus"
                                disabled={!loadedTabs.ruanganKhusus}
                            >
                                {!loadedTabs.ruanganKhusus
                                    ? "Klik tab dulu"
                                    : "Tambah Ruangan Khusus"}
                            </Button>
                        </Stack>
                    </Stack>

                    <Stack
                        direction="row"
                        display="flex"
                        justifyContent="space-between"
                        mt={3}
                    >
                        <Stack
                            direction={{ xs: "row" }}
                            alignItems="center"
                            spacing={2}
                        >
                            <TextField
                                placeholder="Cari"
                                size="medium"
                                value={searchExclusive}
                                onChange={handleChangeSearchExclusive}
                                onKeyPress={(e) => {
                                    const element =
                                        e.target as HTMLInputElement;
                                    if (e.key === "Enter") {
                                        setParamsListRoomExclusive((prev) => ({
                                            ...prev,
                                            search: element.value,
                                            page: 1,
                                        }));
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={handleSearchExclusive}
                                                disabled={
                                                    !loadedTabs.ruanganKhusus
                                                }
                                            >
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                                disabled={!loadedTabs.ruanganKhusus}
                            />

                            <FormControl size="medium" sx={{ width: "50%" }}>
                                <InputLabel id="demo-simple-select-helper-label">
                                    Kategori Ruangan Khusus
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    label="Kategori Ruangan Khusus"
                                    defaultValue="Semua"
                                    onChange={(e) =>
                                        setParamsListRoomExclusive((prev) => ({
                                            ...prev,
                                            status: String(e.target.value),
                                        }))
                                    }
                                    disabled={!loadedTabs.ruanganKhusus}
                                >
                                    <MenuItem value="Semua">
                                        Semua Ruangan
                                    </MenuItem>
                                    <MenuItem value="Tersedia">
                                        Tersedia
                                    </MenuItem>
                                    <MenuItem value="Disewa">Disewa</MenuItem>
                                    <MenuItem value="Akan Berakhir">
                                        Akan Berakhir
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>

                        <Stack
                            direction="row"
                            spacing={2}
                            marginTop={3}
                            marginBottom={1}
                            alignItems="center"
                            // display={
                            //     isPhoneScreen || isTabletScreen ? "none" : undefined
                            // }
                        >
                            <Button
                                // size="small"
                                variant={
                                    isCardViewKhusus ? "contained" : "outlined"
                                }
                                onClick={handleCardViewKhusus}
                                sx={{
                                    padding: "10px",
                                }}
                            >
                                <WindowIcon />
                            </Button>

                            <Button
                                // size="small"
                                variant={
                                    isCardViewKhusus ? "outlined" : "contained"
                                }
                                onClick={handleListViewKhusus}
                                sx={{
                                    padding: "10px",
                                }}
                            >
                                <ViewListIcon />
                            </Button>
                        </Stack>
                    </Stack>

                    <Stack
                        position="relative"
                        spacing={1}
                        mt={4}
                        height={`calc(100vh - 182px)`}
                        overflow="auto"
                    >
                        {isLoadingListRoomExclusive ? (
                            <Spinner />
                        ) : listRoomExclusive ? (
                            <React.Fragment>
                                {listRoomExclusive?.pages[0].results
                                    .totalElements === 0 ? (
                                    <Box
                                        display="flex"
                                        flex={1}
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                        height="100%"
                                    >
                                        <MeetingRoomIcon
                                            sx={{
                                                textAlign: "center",
                                                color: "primary",
                                                fontSize: "50px",
                                                padding: 1,
                                                borderRadius: "100%",
                                                backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                            }}
                                        />
                                        <Typography
                                            fontWeight={600}
                                            fontSize={25}
                                            textAlign="center"
                                            mt={2}
                                        >
                                            Ruangan Tidak ditemukan
                                        </Typography>
                                    </Box>
                                ) : (
                                    <>
                                        {isCardViewKhusus ? (
                                            // Grid View (Card View) - Default
                                            <Grid container spacing={2}>
                                                {listRoomExclusive?.pages.map(
                                                    (page, pageIndex) =>
                                                        page.results.content.map(
                                                            (li) => (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={4}
                                                                    key={`${pageIndex}-${li.id}`}
                                                                >
                                                                    <CardRoomKhusus
                                                                        data={
                                                                            li
                                                                        }
                                                                    />
                                                                </Grid>
                                                            ),
                                                        ),
                                                )}
                                            </Grid>
                                        ) : (
                                            // List View
                                            <Grid container spacing={2}>
                                                {listRoomExclusive?.pages.map(
                                                    (page, pageIndex) =>
                                                        page.results.content.map(
                                                            (li) => (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    key={`${pageIndex}-${li.id}`}
                                                                >
                                                                    <CardListRoomKhusus
                                                                        data={
                                                                            li
                                                                        }
                                                                    />
                                                                </Grid>
                                                            ),
                                                        ),
                                                )}
                                            </Grid>
                                        )}

                                        {hasNextPageExclusive && (
                                            <Box width="100%" paddingY={2}>
                                                <LoadingButton
                                                    variant="outlined"
                                                    onClick={() =>
                                                        fetchNextPageExclusive()
                                                    }
                                                    loading={
                                                        isFetchingNextPageExclusive
                                                    }
                                                    loadingPosition="center"
                                                    size="large"
                                                    fullWidth
                                                >
                                                    {hasNextPageExclusive
                                                        ? "Muat lebih banyak"
                                                        : "Tidak ada lagi yang bisa dimuat"}
                                                </LoadingButton>
                                            </Box>
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                mt={10}
                            >
                                <MeetingRoomIcon
                                    sx={{
                                        textAlign: "center",
                                        color: "primary",
                                        fontSize: "50px",
                                        padding: 1,
                                        borderRadius: "100%",
                                        backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                    }}
                                />
                                <Typography
                                    fontWeight={600}
                                    fontSize={25}
                                    textAlign="center"
                                >
                                    Ruangan Khusus Kosong
                                </Typography>
                                <Typography textAlign="center">
                                    Daftar ruangan khusus kosong silahkan
                                    tambahkan ruangan terlebih dahulu
                                </Typography>
                            </Box>
                        )}
                    </Stack>
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <Stack
                        direction={{
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "row",
                        }}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                        marginY={2}
                    >
                        <Typography fontWeight="bold" fontSize={30}>
                            Daftar Penyewa
                        </Typography>

                        <Stack
                            direction="row"
                            spacing={1.5}
                            justifyContent="end"
                            display="flex"
                            alignItems="center"
                        >
                            <Typography>
                                Jumlah Penyewa:{" "}
                                {!loadedTabs.penyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListPenyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span style={{ fontWeight: "bold" }}>
                                        {listPenyewa?.totalAll}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Penyewa Aktif:{" "}
                                {!loadedTabs.penyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListPenyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#0A5BBB",
                                        }}
                                    >
                                        {listPenyewa?.summary.penyewaAktif}
                                    </span>
                                )}
                            </Typography>

                            <Typography>
                                Penyewa Tidak Aktif:{" "}
                                {!loadedTabs.penyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : isLoadingListPenyewa ? (
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        sx={{ display: "inline-block" }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#119C5B",
                                        }}
                                    >
                                        {listPenyewa?.summary.penyewaTidakAktif}
                                    </span>
                                )}
                            </Typography>

                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                size="large"
                                sx={{ width: "fit-content" }}
                                onClick={() => openModalTambahPenyewa()}
                                data-testid="tambah-ruangan"
                                disabled={
                                    !loadedTabs.penyewa || isLoadingListPenyewa
                                }
                            >
                                {!loadedTabs.penyewa
                                    ? "Klik tab dulu"
                                    : isLoadingListPenyewa
                                      ? "Loading..."
                                      : "Tambah Penyewa"}
                            </Button>
                        </Stack>
                    </Stack>

                    <Box alignItems="center">
                        <Stack
                            direction={{ xs: "row" }}
                            justifyContent="space-between"
                            flexWrap="wrap"
                            alignItems="center"
                            gap={2}
                        >
                            <Stack direction="row" spacing={2} width="40%">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Select
                                            value={
                                                paramsListPenyewa.tanggalAwal ===
                                                    now ||
                                                paramsListPenyewa.tanggalAwal ===
                                                    moment()
                                                        .subtract(7, "days")
                                                        .format("YYYY-MM-DD") ||
                                                paramsListPenyewa.tanggalAwal ===
                                                    moment()
                                                        .subtract(1, "month")
                                                        .format("YYYY-MM-DD") ||
                                                paramsListPenyewa.tanggalAwal ===
                                                    moment()
                                                        .subtract(3, "months")
                                                        .format("YYYY-MM-DD") ||
                                                paramsListPenyewa.tanggalAwal ===
                                                    moment()
                                                        .subtract(1, "years")
                                                        .format("YYYY-MM-DD")
                                                    ? paramsListPenyewa.tanggalAwal
                                                    : "Custom"
                                            }
                                            size="medium"
                                            fullWidth
                                            onChange={handleChangePeriode}
                                            disabled={!loadedTabs.penyewa}
                                        >
                                            <MenuItem value={now}>
                                                Hari ini
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(7, "days")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Minggu Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(1, "month")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Bulan Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(3, "months")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                3 Bulan Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(1, "years")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Tahun Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={"Custom"}
                                                sx={{ display: "none" }}
                                            >
                                                Custom
                                            </MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <DatePicker
                                            className="range-filter"
                                            dateFormat="dd/MM/yyyy"
                                            disabledKeyboardNavigation
                                            onFocus={(e) => e.target.blur()}
                                            selectsRange={true}
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                                if (update[1]) {
                                                    handleChangeJangkaWaktu(
                                                        moment(
                                                            update[0],
                                                        ).format("YYYY-MM-DD"),
                                                        moment(
                                                            update[1],
                                                        ).format("YYYY-MM-DD"),
                                                    );
                                                }
                                            }}
                                            maxDate={today}
                                            minDate={subtractYears(1)}
                                            monthsShown={isPhoneScreen ? 1 : 2}
                                            popperProps={{
                                                modifiers: [
                                                    {
                                                        name: "preventOverflow",
                                                        options: {
                                                            boundary:
                                                                "viewport",
                                                        },
                                                    },
                                                    {
                                                        name: "zIndexFix",
                                                        enabled: true,
                                                        phase: "write",
                                                        fn: ({
                                                            state,
                                                        }: ModifierArguments<any>) => {
                                                            state.styles.popper.zIndex =
                                                                "1500";
                                                        },
                                                    },
                                                ],
                                            }}
                                            customInput={
                                                <Stack
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    direction="row"
                                                    width="100%"
                                                    bgcolor="#FFFF"
                                                    height="57px"
                                                    sx={{
                                                        border: "1px solid #cbcbcb",
                                                        borderRadius: "4px",
                                                        alignItems: "center",
                                                        padding: 2,
                                                        cursor: "pointer",
                                                        opacity:
                                                            !loadedTabs.penyewa
                                                                ? 0.5
                                                                : 1,
                                                    }}
                                                >
                                                    <Typography>
                                                        {moment(
                                                            paramsListPenyewa.tanggalAwal,
                                                        ).format(
                                                            "DD/MM/YYYY",
                                                        )}{" "}
                                                        -{" "}
                                                        {paramsListPenyewa.tanggalAkhir &&
                                                            moment(
                                                                paramsListPenyewa.tanggalAkhir,
                                                            ).format(
                                                                "DD/MM/YYYY",
                                                            )}
                                                    </Typography>
                                                    <ArrowDropDownIcon
                                                        sx={{
                                                            marginRight: "-9px",
                                                        }}
                                                    />
                                                </Stack>
                                            }
                                            disabled={!loadedTabs.penyewa}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>

                            <Stack direction="row" spacing={2}>
                                <LoadingButton
                                    disabled={!ukm || !loadedTabs.penyewa}
                                    loading={isLoading}
                                    loadingPosition="center"
                                    onClick={downloadData}
                                    variant="outlined"
                                    size="large"
                                    sx={{ marginY: 4 }}
                                >
                                    Export Data
                                </LoadingButton>
                            </Stack>
                        </Stack>
                    </Box>

                    {isLoadingListPenyewa ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height={300}
                        >
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        <>
                            <Stack
                                direction={{ xs: "row" }}
                                alignItems="center"
                                spacing={2}
                                mb={2}
                            >
                                <TextField
                                    placeholder="Cari Nama, No.Telepon, NPWP, Alamat Perusahaan, Nama, NPWP, No KTP, No.Telp, Alamat PIC"
                                    size="medium"
                                    value={searchPenyewa}
                                    onChange={handleChangeSearchPenyewa}
                                    onKeyPress={(e) => {
                                        const element =
                                            e.target as HTMLInputElement;
                                        if (e.key === "Enter") {
                                            setParamsListPenyewa((prev) => ({
                                                ...prev,
                                                search: element.value,
                                                page: 1,
                                            }));
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={
                                                        handleSearchPenyewa
                                                    }
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ width: "800px" }}
                                    variant="outlined"
                                />

                                <FormControl
                                    size="medium"
                                    sx={{ width: "15%" }}
                                >
                                    <InputLabel id="demo-simple-select-helper-label">
                                        Status
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        label="Status"
                                        value={paramsListPenyewa.status}
                                        onChange={(e) =>
                                            setParamsListPenyewa((prev) => ({
                                                ...prev,
                                                status: String(e.target.value),
                                            }))
                                        }
                                    >
                                        <MenuItem value="semua">Semua</MenuItem>
                                        <MenuItem value="aktif">Aktif</MenuItem>
                                        <MenuItem value="tidak aktif">
                                            Tidak Aktif
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Stack>

                            {listPenyewa?.content &&
                            listPenyewa.content.length > 0 ? (
                                <Box
                                    sx={{
                                        height: isPhoneScreen ? undefined : 797,
                                        width: "100%",
                                        "& .MuiDataGrid-cell:focus-within": {
                                            outline: "none !important",
                                        },
                                        "& .MuiDataGrid-iconButtonContainer": {
                                            visibility: "visible",
                                            width: "0 !important",
                                        },
                                    }}
                                >
                                    <DataGrid
                                        autoHeight={isPhoneScreen}
                                        density="comfortable"
                                        rows={listPenyewa?.content ?? []}
                                        columns={columns}
                                        components={{
                                            ColumnUnsortedIcon: AscDescIcon,
                                            NoRowsOverlay: NoRowsImage,
                                            LoadingOverlay: LoadingTabel,
                                        }}
                                        disableColumnMenu
                                        disableSelectionOnClick
                                        rowsPerPageOptions={[10]}
                                        paginationMode="server"
                                        loading={isLoadingListPenyewa}
                                        onPageSizeChange={handleOnSizeChange}
                                        onPageChange={handleOnPagination}
                                        rowCount={
                                            listPenyewa?.totalElements ?? 0
                                        }
                                        page={paramsListPenyewa.page - 1}
                                        pageSize={paramsListPenyewa.size}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="center"
                                    alignItems="center"
                                    mt={10}
                                >
                                    <FormatListBulletedIcon
                                        sx={{
                                            textAlign: "center",
                                            color: "primary",
                                            fontSize: "50px",
                                            padding: 1,
                                            borderRadius: "100%",
                                            backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                        }}
                                    />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={25}
                                        textAlign="center"
                                    >
                                        Daftar Penyewa Kosong
                                    </Typography>
                                    <Typography textAlign="center">
                                        Daftar penyewa kosong silahkan tambahkan
                                        penyewa terlebih dahulu
                                    </Typography>
                                </Box>
                            )}
                        </>
                    )}
                </TabPanel>

                <TabPanel value={value} index={3}>
                    <Stack
                        direction={{
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "row",
                        }}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                        marginY={2}
                    >
                        <Typography fontWeight="bold" fontSize={30}>
                            Daftar Pemakaian
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1.5}
                            justifyContent="end"
                            display="flex"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                size="large"
                                sx={{ width: "fit-content" }}
                                onClick={() => openModalTambahInvoice()}
                                data-testid="tambah-ruangan"
                                disabled={
                                    !loadedTabs.pemakaian ||
                                    isLoadingListInvoicePenyewa
                                }
                            >
                                {!loadedTabs.pemakaian
                                    ? "Klik tab dulu"
                                    : isLoadingListInvoicePenyewa
                                      ? "Loading..."
                                      : "Tambah Invoice"}
                            </Button>
                        </Stack>
                    </Stack>

                    <Box alignItems="center">
                        <Stack
                            direction={{ xs: "row" }}
                            justifyContent="space-between"
                            flexWrap="wrap"
                            alignItems="center"
                            gap={2}
                        >
                            <Stack direction="row" spacing={2} width="40%">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Select
                                            value={getSelectValue()}
                                            size="medium"
                                            fullWidth
                                            onChange={
                                                handleChangePeriodeListInvoice
                                            }
                                            disabled={!loadedTabs.pemakaian}
                                        >
                                            <MenuItem value={now}>
                                                Hari ini
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(7, "days")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Minggu Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(1, "month")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Bulan Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(3, "months")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                3 Bulan Terakhir
                                            </MenuItem>
                                            <MenuItem
                                                value={moment()
                                                    .subtract(1, "years")
                                                    .format("YYYY-MM-DD")}
                                            >
                                                1 Tahun Terakhir
                                            </MenuItem>
                                            <MenuItem value={"all"}>
                                                Lihat Semua
                                            </MenuItem>
                                            <MenuItem
                                                value={"Custom"}
                                                sx={{ display: "none" }}
                                            >
                                                Custom
                                            </MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <DatePicker
                                            className="range-filter"
                                            dateFormat="dd/MM/yyyy"
                                            disabledKeyboardNavigation
                                            onFocus={(e) => e.target.blur()}
                                            selectsRange={true}
                                            startDate={startDateListInvoice}
                                            endDate={endDateListInvoice}
                                            onChange={(update) => {
                                                setDateRangeListInvoice(update);
                                                if (update[1]) {
                                                    handleChangeJangkaWaktuListInvoice(
                                                        moment(
                                                            update[0],
                                                        ).format("YYYY-MM-DD"),
                                                        moment(
                                                            update[1],
                                                        ).format("YYYY-MM-DD"),
                                                    );
                                                }
                                            }}
                                            minDate={subtractYears(1)}
                                            monthsShown={isPhoneScreen ? 1 : 2}
                                            popperProps={{
                                                modifiers: [
                                                    {
                                                        name: "preventOverflow",
                                                        options: {
                                                            boundary:
                                                                "viewport",
                                                        },
                                                    },
                                                    {
                                                        name: "zIndexFix",
                                                        enabled: true,
                                                        phase: "write",
                                                        fn: ({
                                                            state,
                                                        }: ModifierArguments<any>) => {
                                                            state.styles.popper.zIndex =
                                                                "1500";
                                                        },
                                                    },
                                                ],
                                            }}
                                            customInput={
                                                <Stack
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    direction="row"
                                                    width="100%"
                                                    bgcolor="#FFFF"
                                                    height="57px"
                                                    sx={{
                                                        border: "1px solid #cbcbcb",
                                                        borderRadius: "4px",
                                                        alignItems: "center",
                                                        padding: 2,
                                                        cursor: "pointer",
                                                        opacity:
                                                            !loadedTabs.pemakaian
                                                                ? 0.5
                                                                : 1,
                                                    }}
                                                >
                                                    <Typography>
                                                        {paramsListInvoicePenyewa.tanggalAwal
                                                            ? `${moment(paramsListInvoicePenyewa.tanggalAwal).format("DD-MM-YYYY")} - ${paramsListInvoicePenyewa.tanggalAkhir ? moment(paramsListInvoicePenyewa.tanggalAkhir).format("DD-MM-YYYY") : ""}`
                                                            : "Semua Tanggal"}
                                                    </Typography>
                                                    <ArrowDropDownIcon
                                                        sx={{
                                                            marginRight: "-9px",
                                                        }}
                                                    />
                                                </Stack>
                                            }
                                            disabled={!loadedTabs.pemakaian}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>

                            <Stack direction="row" spacing={2}>
                                <LoadingButton
                                    disabled={!ukm || !loadedTabs.pemakaian}
                                    loading={isLoading}
                                    loadingPosition="center"
                                    onClick={downloadDataListInvoice}
                                    variant="outlined"
                                    size="large"
                                    sx={{ marginY: 4 }}
                                >
                                    Export Data
                                </LoadingButton>
                            </Stack>
                        </Stack>
                    </Box>

                    {isLoadingListInvoicePenyewa ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height={300}
                        >
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        <>
                            <Box alignItems="center" mt={3} mb={4}>
                                <Stack
                                    direction={{ xs: "row" }}
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <TextField
                                        placeholder="Cari"
                                        size="medium"
                                        value={searchInvoicePenyewa}
                                        onChange={
                                            handleChangeSearchInvoicePenyewa
                                        }
                                        onKeyPress={(e) => {
                                            const element =
                                                e.target as HTMLInputElement;
                                            if (e.key === "Enter") {
                                                setParamsListInvoicePenyewa(
                                                    (prev) => ({
                                                        ...prev,
                                                        search: element.value,
                                                        page: 1,
                                                    }),
                                                );
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={
                                                            handleSearchInvoicePenyewa
                                                        }
                                                    >
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined"
                                    />

                                    <FormControl
                                        size="medium"
                                        sx={{ width: "15%" }}
                                    >
                                        <InputLabel id="demo-simple-select-helper-label">
                                            Status Invoice
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            label="Status Invoice"
                                            value={
                                                paramsListInvoicePenyewa.status
                                            }
                                            onChange={(e) =>
                                                setParamsListInvoicePenyewa(
                                                    (prev) => ({
                                                        ...prev,
                                                        status: String(
                                                            e.target.value,
                                                        ),
                                                    }),
                                                )
                                            }
                                        >
                                            <MenuItem value="Semua">
                                                Semua Status
                                            </MenuItem>
                                            <MenuItem value="unpaid">
                                                Unpaid
                                            </MenuItem>
                                            <MenuItem value="paid">
                                                Paid
                                            </MenuItem>
                                            <MenuItem value="booked">
                                                Booked
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Stack>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                    mb: 3,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Card
                                    sx={{
                                        minWidth: 200,
                                        flex: 1,
                                        borderLeft: "4px solid",
                                        borderLeftColor: "#FFBF00",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            color="text.secondary"
                                            gutterBottom
                                            fontSize={14}
                                        >
                                            Total Transaksi
                                        </Typography>

                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Typography
                                                variant="h4"
                                                component="div"
                                                fontWeight="bold"
                                                color="#FFBF00"
                                            >
                                                {listInvoicePenyewa?.summary
                                                    ?.totalRuangDisewa || 0}
                                            </Typography>
                                            <Typography variant="h5">
                                                ({" "}
                                                {toRupiah(
                                                    listInvoicePenyewa?.summary
                                                        ?.nominalKeseluruhan ||
                                                        0,
                                                )}{" "}
                                                )
                                            </Typography>
                                        </Stack>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mt: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    bgcolor: "#FFBF00",
                                                    mr: 1,
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Total Transaksi
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>

                                <Card
                                    sx={{
                                        minWidth: 200,
                                        flex: 1,
                                        borderLeft: "4px solid",
                                        borderLeftColor: "success.main",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            color="text.secondary"
                                            gutterBottom
                                            fontSize={14}
                                        >
                                            Dibayar
                                        </Typography>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Typography
                                                variant="h4"
                                                component="div"
                                                fontWeight="bold"
                                                color="success.main"
                                            >
                                                {listInvoicePenyewa?.summary
                                                    ?.dibayar || 0}
                                            </Typography>
                                            <Typography variant="h5">
                                                ({" "}
                                                {toRupiah(
                                                    listInvoicePenyewa?.summary
                                                        ?.nominalDibayar || 0,
                                                )}{" "}
                                                )
                                            </Typography>
                                        </Stack>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mt: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    bgcolor: "success.main",
                                                    mr: 1,
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Invoice sudah dibayar
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>

                                <Card
                                    sx={{
                                        minWidth: 200,
                                        flex: 1,
                                        borderLeft: "4px solid",
                                        borderLeftColor: "warning.main",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            color="text.secondary"
                                            gutterBottom
                                            fontSize={14}
                                        >
                                            Booked
                                        </Typography>

                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Typography
                                                variant="h4"
                                                component="div"
                                                fontWeight="bold"
                                                color="warning.main"
                                            >
                                                {listInvoicePenyewa?.summary
                                                    ?.booked || 0}
                                            </Typography>
                                            <Typography variant="h5">
                                                ({" "}
                                                {toRupiah(
                                                    listInvoicePenyewa?.summary
                                                        ?.nominalBooked || 0,
                                                )}{" "}
                                                )
                                            </Typography>
                                        </Stack>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mt: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    bgcolor: "warning.main",
                                                    mr: 1,
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Ruangan dipesan
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>

                                <Card
                                    sx={{
                                        minWidth: 200,
                                        flex: 1,
                                        borderLeft: "4px solid",
                                        borderLeftColor: "error.main",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            color="text.secondary"
                                            gutterBottom
                                            fontSize={14}
                                        >
                                            Belum Dibayar
                                        </Typography>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Typography
                                                variant="h4"
                                                component="div"
                                                fontWeight="bold"
                                                color="error.main"
                                            >
                                                {listInvoicePenyewa?.summary
                                                    ?.belumDibayar || 0}
                                            </Typography>
                                            <Typography variant="h5">
                                                ({" "}
                                                {toRupiah(
                                                    listInvoicePenyewa?.summary
                                                        ?.nominalBelumDibayar ||
                                                        0,
                                                )}{" "}
                                                )
                                            </Typography>
                                        </Stack>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mt: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    bgcolor: "error.main",
                                                    mr: 1,
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Invoice belum dibayar
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>

                            {listInvoicePenyewa?.content &&
                            listInvoicePenyewa.content.length > 0 ? (
                                <Box
                                    sx={{
                                        height: isPhoneScreen ? undefined : 797,
                                        width: "100%",
                                        "& .MuiDataGrid-cell:focus-within": {
                                            outline: "none !important",
                                        },
                                        "& .MuiDataGrid-iconButtonContainer": {
                                            visibility: "visible",
                                            width: "0 !important",
                                        },
                                    }}
                                >
                                    <DataGrid
                                        autoHeight={isPhoneScreen}
                                        density="comfortable"
                                        rows={listInvoicePenyewa?.content ?? []}
                                        columns={columnsListInvoicePenyewa}
                                        components={{
                                            ColumnUnsortedIcon: AscDescIcon,
                                            NoRowsOverlay: NoRowsImage,
                                            LoadingOverlay: LoadingTabel,
                                        }}
                                        disableColumnMenu
                                        disableSelectionOnClick
                                        rowsPerPageOptions={[10]}
                                        paginationMode="server"
                                        loading={isLoadingListInvoicePenyewa}
                                        onPageSizeChange={
                                            handleOnSizeChangeListInvoicePenyewa
                                        }
                                        onPageChange={
                                            handleOnPaginationListInvoicePenyewa
                                        }
                                        rowCount={
                                            listInvoicePenyewa?.totalElements ??
                                            0
                                        }
                                        page={paramsListInvoicePenyewa.page - 1}
                                        pageSize={paramsListInvoicePenyewa.size}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="center"
                                    alignItems="center"
                                    mt={10}
                                >
                                    <FormatListBulletedIcon
                                        sx={{
                                            textAlign: "center",
                                            color: "primary",
                                            fontSize: "50px",
                                            padding: 1,
                                            borderRadius: "100%",
                                            backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                        }}
                                    />
                                    <Typography
                                        fontWeight={600}
                                        fontSize={25}
                                        textAlign="center"
                                    >
                                        Daftar Pemakaian Kosong
                                    </Typography>
                                    <Typography textAlign="center">
                                        Daftar Pemakaian kosong silahkan buat
                                        invoice terlebih dahulu
                                    </Typography>
                                </Box>
                            )}
                        </>
                    )}
                </TabPanel>

                <TabPanel value={value} index={4}>
                    <LaporanCoWork />
                </TabPanel>
            </Box>

            <ModalTambahRuangan
                isOpenModalTambahRuangan={isOpenModalTambahRuangan}
                closeModalTambahRuangan={closeModalTambahRuangan}
                // dataLanggananMember={dataLanggananMember}
            />

            <ModalPindahRuangInvoice 
                isOpenModalPindahRuangInvoice={isOpenModalPindahRuanganInvoice}
                closeModalPindahRuangInvoice={closeModalPindahRuanganInvoice}
                dataInvoice={dataInvoice}
            />

            <ModalTambahRuanganKhusus
                isOpenModalTambahRuanganKhusus={isOpenModalTambahRuanganKhusus}
                closeModalTambahRuanganKhusus={closeModalTambahRuanganKhusus}
            />

            <ModalTambahPenyewa
                isOpenModalTambahPenyewa={isOpenModalTambahPenyewa}
                closeModalTambahPenyewa={closeModalTambahPenyewa}
                dataPenyewa={dataPenyewa}
            />

            <ModalTambahInvoice
                isOpenModalTambahInvoice={isOpenModalTambahInvoice}
                closeModalTambahInvoice={closeModalTambahInvoice}
                dataInvoice={dataInvoice}
            />

            {dataHistoryPenyewa && (
                <ModalHistoryPenyewa
                    isOpenModalHistoryPenyewa={isOpenModalHistoryPenyewa}
                    closeModalHistoryPenyewa={closeModalHistoryPenyewa}
                    idPenyewa={dataHistoryPenyewa.idPenyewa}
                    namaPenyewa={dataHistoryPenyewa.namaPenyewa}
                />
            )}

            {dataDeletePenyewa && (
                <ModalDeletePenyewa
                    isOpenModalDeletePenyewa={isOpenModalDeletePenyewa}
                    closeModalDeletePenyewa={closeModalDeletePenyewa}
                    idPenyewa={dataDeletePenyewa.idPenyewa}
                    namaPenyewa={dataDeletePenyewa.namaPenyewa}
                />
            )}

            {dataDeleteInvoicePenyewa && (
                <ModalDeleteInvoicePenyewa
                    isOpenModalDeleteInvoicePenyewa={
                        isOpenModalDeleteInvoicePenyewa
                    }
                    closeModalDeleteInvoicePenyewa={
                        closeModalDeleteInvoicePenyewa
                    }
                    idInvoicePenyewa={dataDeleteInvoicePenyewa.idInvoicePenyewa}
                    noInvoice={dataDeleteInvoicePenyewa.noInvoice}
                    refetch={refetchListInvoicePenyewa}
                />
            )}
        </React.Fragment>
    );
};

export default Coworking;
